import { Company, Carnet } from 'src/types/data';

// Add a carnet to a rib
export const addCarnet = (companies: Company[], companyId: number, ribId: number, carnet: Carnet): Company[] =>
  companies.map((company) =>
    company.id === companyId
      ? {
          ...company,
          ribs: company.ribs.map((rib) =>
            rib.id === ribId ? { ...rib, carnets: [...rib.carnets, carnet] } : rib
          ),
        }
      : company
  );

// Update a carnet in a rib
export const updateCarnet = (
  companies: Company[],
  companyId: number,
  ribId: number,
  carnet: Carnet
): Company[] =>
  companies.map((company) =>
    company.id === companyId
      ? {
          ...company,
          ribs: company.ribs.map((rib) =>
            rib.id === ribId
              ? {
                  ...rib,
                  carnets: rib.carnets.map((existingCarnet) =>
                    existingCarnet.id === carnet.id ? carnet : existingCarnet
                  ),
                }
              : rib
          ),
        }
      : company
  );

// Remove a carnet from a rib
export const removeCarnet = (
  companies: Company[],
  companyId: number,
  ribId: number,
  carnetId: number
): Company[] =>
  companies.map((company) =>
    company.id === companyId
      ? {
          ...company,
          ribs: company.ribs.map((rib) =>
            rib.id === ribId ? { ...rib, carnets: rib.carnets.filter((carnet) => carnet.id !== carnetId) } : rib
          ),
        }
      : company
  );
